import { CloudKeyOutlineIcon } from './CloudKeyOutlineIcon';

/**
 * author: frankgrinaert
 * id CB6C6880-11B8-4BE6-9EA5-6F4D53EF98EC
 * name cloud-key-outline
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-key-outline.svg
 * tags
 * - Cloud 
 */
export const CloudSecurityOutlineIcon = CloudKeyOutlineIcon;
export default CloudSecurityOutlineIcon